import { Provider } from 'react-redux';
import ReactGA from 'react-ga';
import { ReactChannelIO } from 'react-channel-plugin';
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

import App from './App';
import { store } from '@/services/ConfigureStore';
import { Toaster } from '@/components/ui/sonner';

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
ReactGA.pageview(window.location.pathname + window.location.search);
amplitude.init(process.env.REACT_APP_AMPLITUDE_KEY);
const sessionReplayTracking = sessionReplayPlugin({ sampleRate: 1 });
amplitude.add(sessionReplayTracking);

const Root = () => {
  return (
    <Provider store={store}>
      <ReactChannelIO pluginKey={process.env.REACT_APP_CHANNEL_ID_PLUGIN_KEY} autoBoot>
        <Toaster />
        <App />
      </ReactChannelIO>
    </Provider>
  );
};

export default Root;
